<div *ngFor="let slice of slices">
  <lib-curved-box *ngIf="slice.label === 'bubbled'">
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </lib-curved-box>
  <div *ngIf="slice.label !== 'bubbled'">
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </div>
  <ng-template #contentTemplate>
    <app-lazy-slice [componentType]="slice.type" [slice]="$any(slice)"> </app-lazy-slice>
  </ng-template>
</div>
